import { Pipe, PipeTransform } from '@angular/core';
import { formatSizeUnits } from '@y42/util/format-size-units';

@Pipe({
  name: 'formatSizeUnits',
  pure: false,
})
export class FormatSizeUnitsPipe implements PipeTransform {
  transform(value: number): string {
    return formatSizeUnits(value);
  }
}
